import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";
import { sfx } from "@/lib/soundfx";

// Reaction game: wait for GO!, then snatch the rumal faster than the opponent.
export default function RumalJhapatta() {
  const [phase, setPhase] = useState("ready"); // ready | wait | go | result
  const [msg, setMsg] = useState(null);
  const [win, setWin] = useState(false);
  const [rt, setRt] = useState(null);
  const [wins, setWins] = useState(0);
  const [round, setRound] = useState(1);
  const goAt = useRef(0);
  const cpuMs = useRef(500);
  const timer = useRef(null);
  const cpuTimer = useRef(null);

  const start = () => {
    setPhase("wait"); setMsg(null); setRt(null);
    cpuMs.current = Math.max(220, 620 - round * 35 + Math.random() * 120);
    timer.current = setTimeout(() => {
      setPhase("go"); goAt.current = performance.now();
      // opponent may snatch if you're too slow
      cpuTimer.current = setTimeout(() => finish(null, true), cpuMs.current);
    }, 1200 + Math.random() * 2600);
  };

  const finish = (ms, cpuGrab) => {
    clearTimeout(cpuTimer.current);
    setPhase("result");
    if (cpuGrab) { setWin(false); setMsg("Opponent snatched it first! 😩"); return; }
    setRt(Math.round(ms));
    const w = ms < cpuMs.current;
    setWin(w); if (w) { setWins((x) => x + 1); sfx.hit?.(); } 
    setMsg(w ? `JhapaK! ${Math.round(ms)}ms — you got it! 🎉` : `Too slow (${Math.round(ms)}ms). ⏱️`);
  };

  const grab = () => {
    if (phase === "wait") { clearTimeout(timer.current); setPhase("result"); setWin(false); setMsg("FOUL! Jumped too early. 🚫"); return; }
    if (phase === "go") finish(performance.now() - goAt.current, false);
  };

  const next = () => { setRound((r) => r + 1); setPhase("ready"); };
  useEffect(() => () => { clearTimeout(timer.current); clearTimeout(cpuTimer.current); }, []);

  return (
    <div className="w-full text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Round" value={round} />
        <AScore label="Won" value={wins} />
      </div>
      <p className="my-3 text-sm text-kirana-brown/70">Wait for <b>GO!</b> then tap SNATCH before your friend. Don't jump early!</p>

      <button
        data-testid="rj-arena"
        onClick={phase === "wait" || phase === "go" ? grab : undefined}
        className={`relative mx-auto mb-4 flex h-44 w-full max-w-md items-center justify-center overflow-hidden rounded-md border-2 border-kirana-border transition-colors ${
          phase === "go" ? "bg-kirana-green/80 cursor-pointer" : phase === "wait" ? "bg-[#b23a2e] cursor-pointer" : "bg-gradient-to-b from-[#f6ead0] to-[#e6d3a8]"
        }`}
      >
        {/* two friends squatting, rumal (handkerchief) between them */}
        <div className="pointer-events-none absolute inset-0 flex items-center justify-between px-8">
          <span className="text-5xl" style={{ transform: "scaleX(-1)" }}>🧒</span>
          <span className={`text-4xl transition-transform duration-150 ${phase === "go" ? "scale-150 animate-bounce" : phase === "result" && win ? "opacity-0" : ""}`}>🧣</span>
          <span className="text-5xl">🧑</span>
        </div>
        {phase === "ready" && <span className="relative z-10 rounded bg-black/25 px-2 font-signboard text-lg text-white">Do dost, beech mein rumal…</span>}
        {phase === "wait" && <span className="relative z-10 font-signboard text-2xl font-bold text-white drop-shadow">Ready… wait for it…</span>}
        {phase === "go" && <span className="relative z-10 font-signboard text-4xl font-bold text-white drop-shadow">GO! SNATCH! 🖐️</span>}
        {phase === "result" && <span className="relative z-10 rounded bg-black/30 px-3 text-4xl">{win ? "🎉" : "😩"}</span>}
      </button>

      <div className="mt-2">
        {phase === "ready" && <ABtn data-testid="rj-start" onClick={start} tone="gold" className="px-8 py-3">Start Round</ABtn>}
        {(phase === "wait" || phase === "go") && <ABtn data-testid="rj-grab" onClick={grab} tone="red" className="px-10 py-3 text-lg">SNATCH! 🖐️</ABtn>}
        {phase === "result" && (
          <>
            <AResult testId="rj-result" win={win} text={msg} />
            <div className="mt-3 flex justify-center"><ABtn data-testid="rj-again" onClick={next} tone="green">Next Round</ABtn></div>
          </>
        )}
      </div>
    </div>
  );
}
